import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { ConnectedAccountEntityType } from './connected-account.entity.enum';
import { ConnectedAccountFundsStatus } from './connected-account.funds.status.enum';
import { ProviderType } from './provider.type.enum';

export const ConnectedAccountFundsSchema = WithBaseEntitySchema(
    z.object({
        providerId: z.string(),
        providerType: EnumSchema(ProviderType),
        status: EnumSchema(ConnectedAccountFundsStatus),
        entityType: EnumSchema(ConnectedAccountEntityType),
        entitiesIds: z.array(z.string()).optional(),
        amount: z.number(),
        currency: EnumSchema(Currency),
    }),
).strict();

export class ConnectedAccountFunds extends FromSchema(ConnectedAccountFundsSchema) implements BaseEntity {
    id: string;
    providerId: string;
    providerType: ProviderType;
    status: ConnectedAccountFundsStatus;
    entityType: ConnectedAccountEntityType;
    entitiesIds?: string[];
    amount: number;
    currency: Currency;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    seller?: string;
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
